import { ProductsService } from '@appStore/products/services/product.service';
import { AgreementService } from '@appStore/products/services/agreement.service';

export const services: any[] = [ ProductsService, AgreementService ];

export * from '@appStore/products/services/product.service';
export * from '@appStore/products/services/agreement.service';
